import React from "react";
import ReactApexChart from "react-apexcharts";


function Chart({ inventoryStatus }) {


  const Metals =[];
  const Weights =[];
  
  inventoryStatus?.forEach(item => {        
       Metals.push(item.metalName);
       Weights.push(item.weight)
  });

 
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  const series = [

    {
      name: "Inventory Status",
      data: Weights,
    },
  ];
  const options = {
    title:{
      text:"Inventory Status",
      align: "center"
    },
    chart: {
      zoom: { enabled: true },
      toolbar: {show: false},
    },
    dataLabels: {
      enabled: true,
      formatter: (value) => {
        return `${numberWithCommas(value)}`;
      },
    },
    legend: {
      show: false
    },    

    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "string",
      categories: Metals,
      name:"Metal",
      title: {
        text: "Metal",
      }
    },
    yaxis: {
    type: "number",
     title: {
        text: "Weight",
      } 
      ,labels:{
        formatter: (value) => {
          return `${numberWithCommas(value)}`;
        },
      },   
    },
    tooltip: {
      x: {
        
      },
    },
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        textAlign: "center",
        width: '90%',
        margin: '10px auto',
        padding: '10px'
      }}
    >
      <br />
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={300}
        
      />
    </div>
  );
}

export default Chart